import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { AccountsReceivableLedgerEntity, AccountsReceivableLedgerTypeEnum } from 'src/app/dave-data-module/entities/accounts-receivable-ledger.entity';
import { ArlLvCalculationItem } from '../arl-lv-calculation/arl-lv-calculation-datasource';
import { arlTableData, determineIfIsArlTableDataOrGroupEnd, groupEndPlaceholder } from '../arl-table/arl-table.component';
import { firstValueFrom } from 'rxjs';
import { isNotNullOrUndefined, stringSearch } from '../../../../helper/helper';

export type ArlPositionDialogComponentDialogReturnData = null | number;
export interface ArlPositionDialogComponentDialogData {
    Array?: (groupEndPlaceholder | arlTableData<AccountsReceivableLedgerEntity>)[];
    AllowOnlyLastPositionInGroup?: boolean;
    LvArray?: ArlLvCalculationItem[];
    initialSelectedIndex?: number;
}
@Component({
    selector: 'app-arl-position-dialog',
    templateUrl: './arl-position-dialog.component.html',
    styleUrls: ['./arl-position-dialog.component.scss'],
})
export class ArlPositionDialogComponent {
    data: { label: string; hint?: string; visible?: boolean }[];
    protected allowOnlyLastPositionInGroup: boolean;
    selectedIndex: number | null = null;
    searchString = '';
    protected readonly firstPositionLabel = '01 Als erste Position einfügen';
    constructor(@Inject(MAT_DIALOG_DATA) Data: ArlPositionDialogComponentDialogData) {
        this.allowOnlyLastPositionInGroup = Data?.AllowOnlyLastPositionInGroup ?? false;
        this.initData(Data);
    }

    protected matchesSearch(label: string, hint?: string) {
        return !this.searchString?.trim() || stringSearch([label, hint].filter((v) => !!v).join(' '), this.searchString);
    }

    private async initData(Data: ArlPositionDialogComponentDialogData) {
        const arlGroupMap: { [id: number]: string } = {};
        if (Data.Array) {
            this.data = Data.Array.map((t, i, array) => {                let visible = !this.allowOnlyLastPositionInGroup;
                if (this.allowOnlyLastPositionInGroup){
                    const next = array[i + 1];

                    if (!next || !determineIfIsArlTableDataOrGroupEnd(next)) {
                        visible = true;
                    }
                }
                if (determineIfIsArlTableDataOrGroupEnd(t)) {
                    const information = t?.form?.value?.Information ?? "Position ohne Bezeichnung";
                    if (t?.form?.value?.Type === AccountsReceivableLedgerTypeEnum.Group) {
                        arlGroupMap[t?.form?.value?.Id] = t.form.controls.ItemNumber.getRawValue() + ' ' + information;                    }
                    return { label: t.form.controls.ItemNumber.getRawValue() + ' ' + information, visible: visible };
                } else if (!determineIfIsArlTableDataOrGroupEnd(t)) {
                    return { label: arlGroupMap[t?.groupId] + ' - (Titelende)', visible: visible };
                }
            });
        } else if (Data.LvArray) {
            // const position = await firstValueFrom(t.position$);
            // this.data.push({ label: position + ' ' + t?.information.value });
            this.data = [];
            for (const t of Data.LvArray) {
                console.log(t)
                 const position = t.positionForm?.value ?? "Position ohne Nummer" ;
                 const information = t?.information?.value ?? "Position ohne Bezeichnung";

                if (t.isBookingPosition || (!t.isBookingPosition &&  !t.groupEnd)) {
                    this.data.push({ label: position + ' ' + information, visible: true });
                } else if(t.isGroupEnd && !t.isBookingPosition) {
                    const lable = await firstValueFrom(t.groupEnd.label$)
                    this.data.push( { label: position +' '+lable + ' - (Titelende)', visible: true });
                }
            }
        }

        if (this.data.length > 0) {
            const lastIndex = this.data.length - 1;
            this.data[lastIndex].hint = 'Ganz unten';
            this.selectedIndex = isNotNullOrUndefined(Data.initialSelectedIndex) && Data.initialSelectedIndex > -1 ? Data.initialSelectedIndex : lastIndex;
        }
    }
}
